export const sql = (sql: TemplateStringsArray) => ({ sql })